import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import {ApiService} from "../../services/api.service";

@Component({
    selector: 'app-short-url-redirect',
    templateUrl: './short-url-redirect.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule]
})
export class ShortUrlRedirectComponent implements OnInit {
    private _route = inject(ActivatedRoute);
    private _router = inject(Router);
    private _apiService = inject(ApiService);
    private _toastr = inject(ToastrService);

    public isLoading = true;
    public redirectMessage = 'Redirection en cours...';

    ngOnInit(): void {
        console.log('ici');
        const shortCode = this._route.snapshot.paramMap.get('code');

        if (!shortCode) {
            this._toastr.error('Code court invalide');
            this._router.navigate(['/']);
            return;
        }

        this.redirectToOriginalUrl(shortCode);
    }

    private redirectToOriginalUrl(shortCode: string): void {
        this._apiService.get(`api/extras/short-urls/?short_code=${shortCode}`).subscribe({
            next: (response: any) => {
                if (response && response.results && response.results.length > 0) {
                    const shortUrl = response.results[0];
                    const originalUrl = shortUrl.original_url;
                    const originalDomain = shortUrl.original_domain;

                    try {
                        const url = new URL(originalUrl);
                        const currentDomain = window.location.origin;

                        // Vérifier si le domaine de destination est le même que l'application
                        if (originalDomain === currentDomain || url.origin === currentDomain) {
                            // Navigation interne avec Angular Router
                            const relativePath = url.pathname + url.search + url.hash;
                            this.redirectMessage = 'Chargement...';

                            // Utiliser le Router Angular pour une navigation sans rechargement
                            this._router.navigateByUrl(relativePath).catch(() => {
                                // Si la navigation échoue, fallback sur window.location
                                window.location.href = relativePath;
                            });
                        } else {
                            // Navigation externe - rechargement nécessaire
                            this.redirectMessage = 'Redirection vers un site externe...';
                            window.location.href = originalUrl;
                        }
                    } catch (error) {
                        console.error('URL invalide:', error);
                        this._toastr.error('URL de destination invalide');
                        this.isLoading = false;
                        setTimeout(() => this._router.navigate(['/']), 2000);
                    }
                } else {
                    this._toastr.error('URL courte introuvable');
                    this.isLoading = false;
                    setTimeout(() => this._router.navigate(['/']), 2000);
                }
            },
            error: (error) => {
                console.error('Erreur lors de la récupération de l\'URL:', error);
                this._toastr.error('Erreur lors de la redirection');
                this.isLoading = false;
                setTimeout(() => this._router.navigate(['/']), 2000);
            }
        });
    }
}
